/* eslint-disable prettier/prettier */
import { useState, useEffect } from 'react';
import * as React from 'react';
import { ISelectListItem, IPurchasedService } from '../../Common/types';
import Fetcher from "../../Common/Fetch"
import BuyTariff from "../../Shared/BuyTariff";
import { fetcherPOSTJSON, fetcherGET } from "../../Common/Fetch";
import FileUploader from "../../Common/FileUploader/FileUploader";

import PaidDeposits from "./PaidDeposits";
import ReceivedDeposits from "./ReceivedDeposits";

interface IPropsType {
    
}

function MyDeposits(props: IPropsType) {  
    return (
        <>
            <div className="depositsWrapper DepositsWrapper">
                <h4 className="purpleTextHead">Оплаченные задатки</h4>
                <PaidDeposits />
            </div>

            <div className="depositsWrapper receivedDepositsWrapper">
                <h4 className="purpleTextHead">Принятые задатки</h4>
                <ReceivedDeposits />
            </div>
        </>
    )
}

export default MyDeposits;


    